const orderPage = document.querySelector('.order__wrapper');
if (!orderPage) return;
const orderSection = orderPage.querySelector('.order__section');
if (!orderSection) return;
const orderOverview = orderPage.querySelector('.order__overview');
if (!orderOverview) return;
const orderMain = orderPage.querySelector('.order__main');
if (!orderMain) return;


if (orderPage) ordersInit();

function ordersInit() {
	const orders = orderPage.querySelectorAll('.Order_box_wrap');
	if (!orders) return;

	for (const order of orders) {
		const orderLink = order.querySelector('a.Link');
		orderLink.addEventListener('click', (event) => fetchOrder(event, order))
	}

}

async function fetchOrder(event, order) {
	event.preventDefault();
	const target = event.target;
	if (!target) return;
	const orderHref = target.getAttribute('href');
	if (!orderHref) return;

	if (orderMain) {
		if (orderMain.classList.contains('d-none')) orderMain.classList.remove('d-none');
	}

	try {
		const orderResponse = await fetch(orderHref);

		if (!orderResponse.ok) {
			throw new Error(`HTTP error! Status: ${orderResponse.status}`);
		}

		const contentType = orderResponse.headers.get("content-type");
		if (contentType && contentType.includes("text/html")) {
			const orderRaw = await orderResponse.text();
			const parser = new DOMParser();
			const orderHtml = parser.parseFromString(orderRaw, 'text/html');
			const orderWrapper = orderHtml.querySelector('main#main .PageLayout')
			if (!orderWrapper) return;

			orderOverview.classList.add('d-none');
			if (orderMain) {
				orderMain.innerHTML = orderWrapper.innerHTML;
				renderShowOrdersSection(orderMain);
			}
		} else {
			throw new Error(`Expected text/html but received: ${contentType}`);
		}

	}
	catch (error) {
		console.warn("not good: error occured:", error);
	}
}

function renderShowOrdersSection(orderMain) {
	const showOrders = document.createElement('div');
	const showOrderPlaceholder = document.createElement('div');
	const showOrderIcon = document.createElement('div');

	showOrders.classList.add('show__orders', 'd-none', 'd-xl-flex', 'text--small');

	showOrderPlaceholder.textContent = window.languages.show_orders_overview;

	const backSectionNavigation = document.querySelector('.back-section__wrapper');
	if (backSectionNavigation) {
		const backSectionNavigationIcon = backSectionNavigation.querySelector('.back-section__icon svg');
		if (backSectionNavigationIcon) {
			const backSectionNavigationIconClone = backSectionNavigationIcon.cloneNode(true);
			showOrderIcon.appendChild(backSectionNavigationIconClone)
			showOrders.appendChild(showOrderIcon);
		}
	}

	showOrders.appendChild(showOrderPlaceholder);
	orderMain.appendChild(showOrders);
	showOrders.addEventListener('click', () => returnToOrderOverview(orderMain))


	const orderButtons = orderMain.querySelectorAll('button.ProductForm__AddToCart');
	if (!orderButtons) return;
	[...orderButtons].forEach(orderButton => {
		orderButton.addEventListener('click', (event) => addToCartOrder(event, orderMain))
	})
}

function returnToOrderOverview(orderMain) {
	if (!orderMain || !orderOverview) return;
	orderMain.classList.add('d-none');
	orderMain.innerHTML = "";
	orderOverview.classList.remove('d-none');
}
async function addToCartOrder(event, orderMain) {
	event.preventDefault();
	const tagetButton = event.target;
	if (tagetButton.tagName !== 'BUTTON') return;
	const currentForm = tagetButton.closest('form');
	if (!currentForm) return;

	tagetButton.setAttribute('disabled', 'disabled');
	document.dispatchEvent(new CustomEvent('theme:loading:start'));
	formData = new FormData(currentForm);
	try {
		const orderResponse = await fetch('/cart/add.js', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			},
			body: formData
		})
		document.dispatchEvent(new CustomEvent('theme:loading:end'));

		if (orderResponse.ok) {
			tagetButton.dispatchEvent(new CustomEvent('product:added', {
				bubbles: true,
				detail: {
					variant: currentForm.querySelector('[name="id"]').value,
					quantity: parseInt(currentForm.querySelector('[name="quantity"]') ? currentForm.querySelector('[name="quantity"]').value : currentForm.querySelector('[name="items[0][quantity]"]').value)
				}
			}));
		}
		else if (orderResponse.status === 422) {
			const responseMessage = await orderResponse.json();
			alert(responseMessage.message);
		}

	} catch (err) {
		console.warn("error occured during add-to-cart process")
	}
}